export enum TooltipContext {
    INIT = 'init',
    BUSINESS = 'business',
    PRIVATE = 'private',
    PRO = 'pro',
    STUDY = 'study',
}
